<template>
    <div class="apprentice-simple-card">
        <h5>Groepje bevestigen voor deelopdracht "{{ subAssignmentIn.name }}"</h5>

        <p>{{ groupLeader.user.full_name }} heeft je uitgenodigd om samen te werken aan {{ subAssignmentIn.name }}</p>

        <b-button
            class="btn"
            variant="primary"
            @click="confirm()"
            >Bevestigen</b-button
        >
        <b-button
            class="btn"
            variant="danger"
            @click="deny()"
            >Weigeren</b-button
        >
    </div>
</template>

<script>
export default {
    name: 'design-2021-assignment-show-sub-assignment-partner-confirm-component',
    props: {
        subAssignmentIn: Object,
    },
    data() {
        return {
            groupLeader: this.subAssignmentIn.getAssignmentPartnerForUser(this.$authUser.id).groupLeader(),
        };
    },
    methods: {
        confirm() {
            this.alert.saving();
            const assignmentPartnerUser = this.subAssignmentIn.getAssignmentPartnerUserForUser(this.$authUser.id);
            this.axios.post(this.routes.assignmentPartnerUserConfirm(assignmentPartnerUser.id)).then(
                (response) => {
                    assignmentPartnerUser.update(response.data);
                    this.alert.success();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
        deny() {
            this.alert.saving();
            const assignmentPartnerUser = this.subAssignmentIn.getAssignmentPartnerUserForUser(this.$authUser.id);
            this.axios.delete(this.routes.assignmentPartnerUserDeny(assignmentPartnerUser.id)).then(
                (response) => {
                    assignmentPartnerUser.remove();
                    this.alert.success();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
    },
};
</script>

<style scoped></style>
